var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseApiClient } from "./BaseApiClient";
export var EVENTS_ENDPOINTS = {
    BY_EVENT_ID: "/Events/GetByEventId",
    BY_LEAGUE_ID: "/Events/GetByLeagueId",
    BY_SPORT_ID: "/Events/GetBySportId",
    BY_EVENT_ID_OR_BY_LEAGUE_ID: "/Events/GetByEventIdOrByLeagueId",
    FROM_TOP_LEAGUES_BY_SPORT_ID: "/Events/GetFromTopLeaguesBySportId",
    COUNT_BY_TAG: "/Events/GetCountByTag",
    BY_REGION_ID: "/Events/GetByRegionIdAndSportId",
    PERSONALIZED_LIVE_EVENTS_BY_ID: "/Events/GetPersonalizedLive",
    BY_ID_FOR_BETSLIP: "/Events/GetByEventIdForBetSlip"
};
/**
 * EventsApiClient - client for fetching Leagues BFF endpoints
 * @export
 * @class EventsApiClient
 * @extends {BaseApiClient}
 */
var EventsApiClient = /** @class */ (function (_super) {
    __extends(EventsApiClient, _super);
    function EventsApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Fetch events by ids from BFF
     * @param {request} EventsByEventIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    EventsApiClient.prototype.getByEventsId = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.BY_EVENT_ID, fetchOptions);
    };
    /**
     * Fetch events by league ids from BFF
     * @param {request} EventsByLeagueIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    EventsApiClient.prototype.getByLeaguesId = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.BY_LEAGUE_ID, fetchOptions);
    };
    /**
     * Fetch events by sport ids from BFF
     * @param {request} EventsBySportIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    EventsApiClient.prototype.getBySportId = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.BY_SPORT_ID, fetchOptions);
    };
    /**
     * Fetch events from top leagues by sport id from BFF
     * @param {request} EventsFromTopLeaguesBySportIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    EventsApiClient.prototype.getFromTopLeaguesBySportId = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.FROM_TOP_LEAGUES_BY_SPORT_ID, fetchOptions);
    };
    /**
     * Fetch events count by tag from BFF
     * @param {request} EventsCountByTagRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    EventsApiClient.prototype.getCountByTag = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.COUNT_BY_TAG, fetchOptions);
    };
    /**
 * Fetch events count by tag from BFF
 * @param {request} EventsByRegionIdAndSportIdRequest
 * @throws {RequiredError}
 * @memberof EventsApiClient
 */
    EventsApiClient.prototype.getByRegionId = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.BY_REGION_ID, fetchOptions);
    };
    /**
     * Fetch events by event Ids or by league Ids from BFF
     * @param {request} EventsByEventIdOrByLeagueIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    EventsApiClient.prototype.getByEventIdOrByLeagueId = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.BY_EVENT_ID_OR_BY_LEAGUE_ID, fetchOptions);
    };
    /**
     * Fetch personalized live events from BFF, based on a selected event's id
     * @param {request} PersonalizedLiveEventsRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    EventsApiClient.prototype.getPersonalizedEvents = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.PERSONALIZED_LIVE_EVENTS_BY_ID, fetchOptions);
    };
    /**
     * Fetch events and markets from BFF, used for Betslip integration
     * @param {request} EventsByEventIdForBetSlipRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    EventsApiClient.prototype.getByIdForBetslip = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.BY_ID_FOR_BETSLIP, fetchOptions);
    };
    return EventsApiClient;
}(BaseApiClient));
export { EventsApiClient };
//# sourceMappingURL=EventsApiClient.js.map